import { EntriFlowStatus } from '@wix/domains-serverless-interface';
export const buildMobileEntriDivertStatus = _ref => {
  let divert = _ref.divert,
    StatusComponent = _ref.StatusComponent;
  return handlers => _ref2 => {
    let domainName = _ref2.domainName,
      msid = _ref2.msid,
      siteName = _ref2.siteName,
      externalViewer = _ref2.externalViewer,
      actionHandler = _ref2.actionHandler;
    return {
      action: async () => {
        if (!msid || !siteName) {
          await (actionHandler == null ? void 0 : actionHandler({
            result: EntriFlowStatus.manual,
            domainName,
            externalViewer,
            msid,
            siteName
          }));
          return;
        }
        await divert({
          domainName,
          metaSiteId: msid,
          siteName
        }, handlers);
      },
      StatusComponent
    };
  };
};
//# sourceMappingURL=mobileEntriDivertStatus.js.map